export default __webpack_public_path__ + "static/media/candidate-viewer-logo.2c79283e.svg";